











import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CodeEntry extends Vue {
    @Prop()
    value: string;

    mounted() {
        // Import previous value.
        const keys = Object.keys(this.$refs);

        this.value.split("").forEach((digit, idx) => {
            (<any>this.$refs[keys[idx]]).value = digit;
        });

        for (const key of keys) {
            (<any>this.$refs[key]).addEventListener("focus", () => {
                document.body.classList.add("in-input");
            });

            (<any>this.$refs[key]).addEventListener("blur", () => {
                document.body.classList.remove("in-input");
            });
        }
    }

    nextCharacter(ev: KeyboardEvent) {
        const tgt: HTMLInputElement = <HTMLInputElement>ev.target;
        const next = tgt.getAttribute("data-next");

        if (tgt.value.length > 0 && next) {
            // Go to next.
            (<any>this.$refs[next]).focus();
        }

        const total = Object.keys(this.$refs).map(x => (<any>this.$refs[x]).value).join("");
        this.$emit("input", total);
    }

    maybePreviousCharacter(ev: KeyboardEvent) {
        const tgt: HTMLInputElement = <HTMLInputElement>ev.target;

        // If this is backspace and we're currently empty, go back to previous.
        if (ev.which === 8 && !tgt.value) {
            const prev = tgt.getAttribute("data-prev");
            if (!prev) return;

            // Clear previous and focus.
            (<any>this.$refs[prev]).value = "";
            (<any>this.$refs[prev]).focus();

            return;
        }

        // If there was already a value in here, don't accept another.
        if (tgt.value.length && ev.which !== 8) {
            ev.preventDefault();
        }
    }
}
